export { default } from './ImageBorderedBox';
export * from './ImageBorderedBox';
